import { BareModal } from '@cb/apricot-react'
import { useState } from 'react'
import { adjustModalHeight } from '../../../../utilities/dom'
import { SAVE } from './constants'
import BigFutureForm from '../../profileandreg/BigFutureForm'

const ID = 'bigFutureModal'

function BigFutureModal({ changeStep }) {
  const [open, setOpen] = useState(true)
  const isStandAlone = typeof changeStep !== 'function'
  const useAnimation = true

  const adjustHeight = () => adjustModalHeight(`#${ID}`)

  return (
    <BareModal
      modalId={ID}
      open={open}
      openAnimation={useAnimation}
      closeAnimation={useAnimation}
      clickOverlayToClose={!isStandAlone}
      escClose={!isStandAlone}
      shadowRoot
      modalNode
      onClose={() => setOpen(false)}
    >
      {open ? (
        <BigFutureForm
          changeStep={changeStep}
          nextStep={SAVE}
          adjustHeight={adjustHeight}
        />
      ) : (
        <div className="cb-modal-content">
          <span className="sr-only">modal content</span>
        </div>
      )}
    </BareModal>
  )
}

export default BigFutureModal
